import * as types from './types';

/**
 *
 * @param {Object} payload
 * @param {String} payload.title
 * @param {Function} payload.onUser
 * @param {Boolean} payload.closeOnUser
 * @param {Function} payload.onError
 * @param {Boolean} payload.closeOnError
 */
export const requestAccess = ({
  title,
  onUser,
  closeOnUser = true,
  onError = () => {},
  closeOnError = false,
}) => {
  return {
    type: types.REQUEST_ACCESS,
    payload: {
      title,
      onUser,
      closeOnUser,
      onError,
      closeOnError,
    },
  };
};

export const closeAccessPrompt = () => ({
  type: types.CLOSE_ACCESS_PROMPT,
});

export const resetAccessPrompt = () => ({
  type: types.RESET_ACCESS_PROMPT,
});



// WEBPACK FOOTER //
// ./src/common/Components/AccessPrompt/state/actions.js